
import React, { useEffect, useState, useRef, useCallback } from 'react';
import DataGrid, { Selection, RowDragging, Column, Editing, Scrolling, Paging, Toolbar, Item, MasterDetail, Export, RequiredRule } from 'devextreme-react/data-grid';

import Form, { Item as ItemForm, GroupItem, ColCountByScreen } from 'devextreme-react/form';
import './EntryRelayForm.scss';
import { getSizeQualifier, useScreenSize } from '../../../utils/media-query';
import { Button, ButtonGroup, NumberBox, Switch, TextBox } from 'devextreme-react';
import { GENDERS } from '../../../shared/constants';
import { EditCellTimeComponent, EditFormTimeComponent, TimeBox, TimeBoxBold } from '../../utils/time-box/TimeBox';
import { TimeDropdownBox, TimeDropdownBoxCounter } from '../../utils/time-dropdownbox/TimeDropdownBox';
import { FormPopup } from '../../utils/form-popup/FormPopup';
import { ResultPopup } from '../result-popup/ResultPopup';
import { withLoadPanel } from '../../../utils/withLoadPanel';
import SelectBox from 'devextreme-react/select-box';
import Validator, {
    CustomRule
} from 'devextreme-react/validator';
import { DataSource } from 'devextreme/common/data';


export const EntryRelayForm = ({ initData, onSave, allowEditing, onDataChanged, athletes }) => {
    const currentRow = useRef(null);



    const cellPrepared = (e) => {
        if (e.rowType === "data" && e.column.dataField === "entrySwimtime") {
            if (e.data.entry == true && (e.data.entrySwimtime == null || e.data.entrySwimtime == 0)) {
                e.cellElement.style.backgroundColor = "#ff9999";
            } else {
                e.cellElement.style.backgroundColor = "";
            }
        }
    }

    const [entryData, setentryData] = useState(initData);
    const { isXSmall } = useScreenSize();
    const gridRef = useRef(null);
    useEffect(() => {
        setentryData(initData);

    }, [initData]);


    const stylingMode = 'filled';
    const updateData = (e) => {
        onDataChanged(entryData);
    };
    const updateField = (field) => (value) => {
        if (!entryData) return;
        setentryData((prevEntryData) => {
            const updatedData = { ...prevEntryData, [field]: value };
            onDataChanged(updatedData); // Aktuellen Zustand weitergeben
            return updatedData;
        });

    };
    const updatePositions = (athletes) => {
        return athletes.map((athlete, index) => ({
            ...athlete,
            position: index + 1, // Position basierend auf dem Index neu zuweisen
        }));
    };
    return (
        <div>
            <Form

                colCount={2} // Anzahl der Spalten

            >
                {/* Event ID Dropdown */}
                <ItemForm>
                    <SelectBox
                        label='Wettkampf'
                        width='100%'
                        value={entryData.eventId}
                        dataSource={entryData.events}
                        displayExpr={(item) => {
                            if (!item) return '';
                            const genderObj = GENDERS.find((gender) => gender.id === item.eventGender);
                            const genderText = genderObj ? genderObj.text : 'Unbekannt';
                            return `${item.swimstyleName} (${item.sessionName}: Wettkampf ${item.eventNumber} (${genderText}))`;
                        }}
                        valueExpr='eventId'
                        placeholder='Event auswählen'
                        stylingMode={stylingMode}
                        onValueChange={updateField('eventId')}
                    />
                </ItemForm>
                <ItemForm>
                    <SelectBox
                        label='Verein'
                        width='100%'
                        value={entryData.clubId}
                        dataSource={entryData.clubs}
                        displayExpr='clubName'
                        valueExpr='clubId'
                        placeholder='Verein auswählen'
                        stylingMode={stylingMode}
                        onValueChange={updateField('clubId')}
                    />
                </ItemForm>
                <ItemForm>
                    <NumberBox
                        label='Staffel-Nummer'
                        width='100%'
                        value={entryData.number}
                        placeholder='Staffel-Nummer'
                        stylingMode={stylingMode}
                        onValueChange={updateField('number')}
                    />
                </ItemForm>
                <ItemForm>
                    <TextBox
                        label='Staffel-Name'
                        width='100%'
                        value={entryData.relayName}
                        placeholder='Staffel-Name'
                        stylingMode={stylingMode}
                        onValueChange={updateField('relayName')}
                    />
                </ItemForm>
                <ItemForm colSpan={2}>
                    <EditFormTimeComponent
                        value={entryData.entrySwimtime || 0} // Fallback-Wert verwenden
                        onValueChange={(e) => { updateField('entrySwimtime')(e) }}
                        label='Meldezeit'
                        stylingMode={stylingMode}
                    />
                </ItemForm>
            </Form>
            <DataGrid
                className='relay-athletes-grid'
                dataSource={entryData.athletes}
                remoteOperations={true}
                width={'100%'}
                height={isXSmall ? 'calc(100vh - 120px)' : 'calc(100vh - 280px)'}
                rowAlternationEnabled={true}
                ref={gridRef}
                keyExpr="position"
                onSaved={updateData}
                onCellPrepared={cellPrepared}
                showBorders={true}
                onRowInserted={(e) => {
                    // Setze die Position für neue Zeilen
                    const updatedAthletes = [...entryData.athletes, { ...e.data, position: entryData.athletes.length + 1 }];
                    const correctedAthletes = updatePositions(updatedAthletes); // Positionen korrigieren
                    setentryData((prev) => ({ ...prev, athletes: correctedAthletes }));
                }}
                onRowRemoved={(e) => {
                    const updatedAthletes = entryData.athletes.filter((athlete) => athlete.position !== e.data.position);
                    const correctedAthletes = updatePositions(updatedAthletes); // Positionen korrigieren
                    setentryData((prev) => ({ ...prev, athletes: correctedAthletes }));
                }}
            >
                <Editing
                    mode="cell"
                    allowUpdating={allowEditing}
                    allowAdding={allowEditing}
                    allowDeleting={allowEditing}
                />
                <RowDragging
                    allowReordering={allowEditing}
                    onReorder={(e) => {
                        const visibleRows = e.component.getVisibleRows();
                        const newAthletes = [...entryData.athletes];
                        const toIndex = newAthletes.findIndex((item) => item.position === visibleRows[e.toIndex].data.position);
                        const fromIndex = newAthletes.findIndex((item) => item.position === e.itemData.position);
                        newAthletes.splice(fromIndex, 1);
                        newAthletes.splice(toIndex, 0, e.itemData);
                        const correctedAthletes = updatePositions(newAthletes); // Positionen korrigieren
                        setentryData((prev) => ({ ...prev, athletes: correctedAthletes }));
                    }}
                />
                <Column
                    dataField="athleteId"
                    caption="Sportler"

                    lookup={{
                        dataSource: {
                            store: athletes.store, // Verwende den Store des dataSource-Objekts
                            filter: [['clubId', '=', entryData.clubId], ['competitionId', '=', entryData.competitionId]], // Filtere nach clubId
                            sort: [{ selector: 'lastname', desc: false }], // Sortiere nach lastname
                        },
                        displayExpr: (item) => {
                            if (!item) return '';
                            const birthYear = new Date(item.dateofbirth).getFullYear(); // Extrahiere das Jahr aus dateOfBirth
                            return `${item.surname} ${item.lastname} (${birthYear})`;
                        },
                        valueExpr: 'athleteId',
                        searchExpr: ['surname', 'lastname'],
                        allowSearch: true
                    }}
                />
                <Column
                    dataField="position"
                    caption="Position"

                    allowEditing={false} // Position wird automatisch aktualisiert
                />
                <Toolbar>
                    <Item location="before">
                        <Button
                            icon='plus'
                            type='default'
                            stylingMode='contained'
                            onClick={() => {
                                if (entryData.athletes.length < 4) {
                                    const newAthlete = { athleteId: null, position: entryData.athletes.length + 1 };
                                    setentryData((prev) => ({
                                        ...prev,
                                        athletes: [...prev.athletes, newAthlete],
                                    }));
                                }
                            }}
                        />

                    </Item>
                </Toolbar>
                <Paging enabled={false} />

            </DataGrid>


        </div>

    );
};
